
































































































































































































































import { uniqueId } from 'lodash-es';
import { mapActions, mapState } from 'vuex';
import { MetadataType } from '@adobe/edex/ui/shared/frontend/utils/types';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  props: ['data'],
  components: {
    Datepicker: () =>
      import(/* webpackChunkName: "datepicker" */ 'vuejs-datepicker'),
    Multiselect: () =>
      import(/* webpackChunkName: "externals" */ 'vue-multiselect').then(
        ({ Multiselect }) => Multiselect
      ),
  },
  data() {
    return {
      attempted: false,
      formData: null,
      MODAL_NAME: uniqueId('new-experience'),
    };
  },
  computed: {
    ...mapState('member', ['member']),
    ...mapState('metadata', [
      'schoolTypes',
      'educationSegments',
      'jobFunctions',
      'countries',
      'regions',
    ]),
    filteredRegions() {
      if (!this.formData?.country) {
        return [];
      }
      return this.regions.filter(
        ({ countryID }) => countryID === this.formData.country.id
      );
    },
    sortedCountries() {
      const mutatedCountries = [...this.countries]
      mutatedCountries.sort((countryA, countryB) => this.$t(countryA.i18nLabel).localeCompare(this.$t(countryB.i18nLabel)));
      return mutatedCountries
    },
    formIsReady() {
      return (
        this.formData &&
        this.schoolTypes &&
        this.educationSegments &&
        this.jobFunctions &&
        this.countries &&
        this.regions
      );
    },
    formIsValid() {
      if (!this.formData) {
        return false;
      }
      return (
        this.formData.institution &&
        this.formData.jobFunction &&
        this.formData.schoolType &&
        this.formData.educationSegments?.length &&
        this.formData.city &&
        this.formData.jobTitle &&
        this.formData.startDate &&
        (this.formData.currentlyWorkHere || this.formData.endDate)
      );
    },
  },
  destroyed() {
    this.hideModal();
  },
  methods: {
    ...mapActions('metadata', ['fetchByType']),
    isInvalid(value) {
      return this.attempted && (!value || value.length === 0);
    },
    fetchMetadata() {
      this.fetchByType(MetadataType.schoolTypes);
      this.fetchByType(MetadataType.educationSegments);
      this.fetchByType(MetadataType.jobFunctions);
      this.fetchByType(MetadataType.countries);
      this.fetchByType(MetadataType.regions);
    },
    getI18nLabel({ i18nLabel }) {
      return this.$t(i18nLabel);
    },
    onRemoveItem(experience) {
      this.items = this.items.filter((item) => item.id !== experience.id);
    },
    async onSubmit() {
      this.attempted = true;
      if (!this.formIsValid) {
        return;
      }
      if (!this.filteredRegions.length) {
        this.formData.region = null;
      }
      const { startDate, endDate } = this.formData;
      this.$emit('submitted', {
        ...this.formData,
        startDate: this.$moment.utc(startDate).format('YYYY-MM-DD'),
        endDate: endDate && this.$moment.utc(endDate).format('YYYY-MM-DD'),
      });
    },
    showModal() {
      this.fetchMetadata();
      this.$modal.show(this.MODAL_NAME);
    },
    hideModal() {
      this.attempted = false;
      this.$modal.hide(this.MODAL_NAME);
    },
    onCancel() {
      this.hideModal();
    },
  },
  watch: {
    data: {
      handler() {
        if (this.data) {
          this.showModal();
          this.formData = { ...this.data };
        } else {
          this.hideModal();
          this.formData = null;
        }
      },
      immediate: true,
    },
  },
};
